import React, { useState, useContext } from 'react';
import classnames from 'classnames';

import Context from "../context/context";

import Checkboxes from './Checkboxes';
import Dates from './Dates';
import FilterSearch from './FilterSearch';


const Widget = props => {
  const {filterNav, setFilterNav, setNavStatus } = useContext(Context);
  const {widget, clearAllFilters} = props;
  const [activeCheckboxGroup, setActiveCheckboxGroup] = useState("");

  const toggleFilterNav = (e) => {

    let any_filters_open = false;
    let updatedFilterNav = [...filterNav];
    updatedFilterNav.map((nav, i) => {
      if (nav.id == widget.id){
        nav.open =  !widget.open;
      } else {
        nav.open = false;
      }
      if (nav.open) {
        any_filters_open = true;
        setNavStatus(true);

      } else {
        setNavStatus(false);
      }
    })
    setFilterNav(updatedFilterNav)
  }

  const handleCheckboxGroupClick = (name) => {
    if (activeCheckboxGroup == name){
      setActiveCheckboxGroup("");
    } else {
      setActiveCheckboxGroup(name);
    }
  }

 
    return (
      widget.filters.map((filter, i) => {
        switch(filter.type){
          case "date":
            return <Dates open={widget.open} single={true} key={i} widget={widget} data={filter} title={widget.title} clearAllFilters={clearAllFilters} active={activeCheckboxGroup} handleClose={() => toggleFilterNav()} multi={widget.filters.length > 1}  />
            break;

          case "checkbox":
            return <Checkboxes open={widget.open} single={true} key={i} widget={widget} data={filter} title={widget.title} clearAllFilters={clearAllFilters} active={activeCheckboxGroup} handleClose={() => toggleFilterNav()} multi={widget.filters.length > 1}   />
            break;

          case "search":
            return <FilterSearch open={widget.open} single={true} key={i} widget={widget} data={filter} title={widget.title} clearAllFilters={clearAllFilters} active={activeCheckboxGroup} handleClose={() => toggleFilterNav()} multi={widget.filters.length > 1}   />
            break;

          default:
            <div>Error</div>
        }
      })



    )
  
  }

export default Widget;
